import React, { useEffect, useMemo, useState } from 'react';
import ModalCreateComentario from './ModalCreateComentario';
import ItemComentario from './ItemComentario';
import { makeStyles, Tooltip } from '@material-ui/core';

const ContainerItemComentarios = ({ item, api, enableHighlight, setEnableHighlight }) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [data, setData] = useState(item.comentarios);

	const useStyles = makeStyles((theme) => ({
		root: {
			flexGrow: 1,
			width: '100%',
			backgroundColor: theme.palette.background.paper,
		},
		tooltip: {
			fontSize: '12px',
		},
	}));

	useEffect(() => {
		setData(item.comentarios);
	}, [item]);

	const counts = useMemo(() => {
		const total = (item.comentarios || []).length;
		const pending = (item.comentarios || []).filter((c) => c.resolvido === false).length;
		const resolved = total - pending;
		return { total, pending, resolved };
	}, [item]);

	const handleModal = (value) => {
		setIsModalOpen(value);
	}

	const handleShowAll = () => {
		setData(item.comentarios);
	}

	const handleFilterPending = () => {
		const updateArray = item.comentarios.filter(c => c.resolvido === false);
		setData(updateArray);
	}

	const handleFilterResolved = () => {
		const updateArray = item.comentarios.filter(c => c.resolvido === true);
		setData(updateArray);
	}

	const classes = useStyles();

	    // Highlight toggle is controlled by parent; call setter directly on click
	return (
		<div style={{
			width: '30%',
			transition: 'width 0.3s',
			display: 'flex',
			flexDirection: 'column',
			gap: '8px'
		}}>
			<div style={{
				width: '100%',
				display: 'flex',
				flexDirection: 'column',
				gap: '8px'
			}}>
				<div style={{ width: '100%', display: 'grid', gridTemplateColumns: '1fr 1fr' }}>
					<Tooltip
						placement="top"
						title="Adicionar comentário"
						classes={{ tooltip: classes.tooltip }}
						arrow
					>
						<button
							className="btn"
							onClick={() => handleModal(true)}
							aria-label="Adicionar comentário"
						>
							<i className="fas fa-plus-circle" style={{ fontSize: 14 }} />
							<span style={{ marginLeft: 6, fontSize: 13 }}>Adicionar</span>
						</button >
					</Tooltip>
					<Tooltip
						placement="top"
						title="Adicionar comentário por marcação de texto"
						classes={{ tooltip: classes.tooltip }}
						arrow
					>
						<button
							className="btn"
							onClick={() => setEnableHighlight && setEnableHighlight(!enableHighlight)}
							aria-label="Adicionar por marcação"
						>
							<i className="fas fa-highlighter" style={{ fontSize: 14 }} />
							<span style={{ marginLeft: 6, fontSize: 13 }}>{enableHighlight ? 'Desmarcar' : 'Marcar'}</span>
						</button >
					</Tooltip>

					<Tooltip
						placement="top"
						title="Listar todos"
						classes={{ tooltip: classes.tooltip }}
						arrow
					>
						<button
							className="btn"
							onClick={() => handleShowAll()}
							aria-label="Listar todos"
						>
							<i className="fas fa-comment-dots" style={{ color: '#4A4A4A', fontSize: 14 }} />
							<span style={{ marginLeft: 6, fontSize: 13 }}>Todos</span>
						</button >
					</Tooltip>

					<Tooltip
						placement="top"
						title="Comentários pendentes"
						classes={{ tooltip: classes.tooltip }}
						arrow
					>
						<button
							className="btn"
							onClick={() => handleFilterPending()}
							aria-label="Filtrar pendentes"
							disabled={counts.pending === 0}
						>
							<i className="fas fa-times-circle" style={{ color: '#D9534F', fontSize: 14 }} />
							<span style={{ marginLeft: 6, fontSize: 13 }}>Pendentes</span>
						</button >
					</Tooltip>

					<Tooltip
						placement="top"
						title="Comentários resolvidos"
						classes={{ tooltip: classes.tooltip }}
						arrow
					>
						<button
							className="btn"
							onClick={() => handleFilterResolved()}
							aria-label="Filtrar resolvidos"
							disabled={counts.resolved === 0}
						>
							<i className="fas fa-check-circle" style={{ color: '#28A745', fontSize: 14 }} />
							<span style={{ marginLeft: 6, fontSize: 13 }}>Resolvidos</span>
						</button >
					</Tooltip>
				</div>

				{(!data || data.length === 0) && (
					<div style={{
						padding: '12px',
						border: '1px dashed #ddd',
						borderRadius: '6px',
						color: '#666',
						textAlign: 'center'
					}}>
						Nenhum comentário para exibir.
					</div>
				)}

				{data && data.map((elem) => (
					<ItemComentario
						key={elem.id}
						comentario={elem}
						avaliacaoItem={item}
						api={api}
					/>
				))}
			</div>
			<ModalCreateComentario
				isModalOpen={isModalOpen}
				handleModal={handleModal}
				avaliacaoItem={item}
				api={api}
			/>
		</div >
	);
}

export default ContainerItemComentarios;
